import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import DatabaseService from 'services/DatabaseService.js';
import {fetchMyProfile, setUserNoCompany} from 'actions/user.js';
import {initNavbarState, setNavbarLogoutButtonEnable} from 'actions/navbar.js';
import {NavControl} from 'modules/navigation/NavBarContainer.js';
import UserService from '../../services/UserService.js';
import Utils from 'utils/Utils.js';

import GroupSelect from './GroupSelect.js';
import EnterGroupCodeContainer from './EnterGroupCodeContainer.js';

class GroupSelectContainer extends Component {

    constructor(props){
		super(props);
        this.state = {showEnterGroupCode:false, 
                      switchCompanyError:'',
                      error:'', 
                      busy:false,
                      selectedGroupCode:null,
                      companies:[]};

        this.onSelectInvite = this.onSelectInvite.bind(this);
		this.onSelectCompanyCode = this.onSelectCompanyCode.bind(this);
		this.onShowEnterGroupCode = this.onShowEnterGroupCode.bind(this);
		this.onHideEnterGroupCode = this.onHideEnterGroupCode.bind(this);
        this.onHideError = this.onHideError.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel  = this.onCancel.bind(this);
    }

    componentWillMount() {
        if(!this.props.noNav) {
            this.props.dispatch(initNavbarState({enable:true, mode:'light', backButtonEnable:false, logoutButtonEnable:true}));
        }
        this.loadData();
    }

    componentWillUnmount() {
        this.props.dispatch(setNavbarLogoutButtonEnable(false));
    }

    loadData() {
        this.setState({busy:true});
        DatabaseService.getCompanyInvitations()
                       .then(result=> {
                           console.log('getCompanyInvitations=>', result);
                           var companies = result.companies || [];
                           var consumer = result.consumer;
                           this.setState({companies:companies, consumer:consumer});
                       })
                       .catch(error=> {
                           console.error('ERROR:');
                           console.error(error);
                           this.setState({error:error});
                        })
                        .then(()=>{
                            this.setState({busy:false});
                        });
    }

    onSelectCompanyCode(code) {
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        return DatabaseService.switchCompany(code)
                        .then((result)=>{
                            this.props.dispatch(setUserNoCompany(false));
                            return this.props.dispatch(fetchMyProfile({surveys:true, plugins:true, health:true, rank:true, categories:true}))
                                        .then(()=>{
                                            this.props.onSwitchCompany();
                                        });
                        }, 
                        error=>{
                            this.setState({switchCompanyError:error});
                        })
                        .then(()=>{
                            this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
                        });
    }

    onShowEnterGroupCode() {
        this.props.dispatch(setNavbarLogoutButtonEnable(false))
        this.setState({showEnterGroupCode:true});
    }

    onHideEnterGroupCode() {
        this.setState({showEnterGroupCode:false});
        this.props.dispatch(setNavbarLogoutButtonEnable(true))
    }

    onSelectInvite(groupCode) {
        if(this.props.isSwitch) {
            this.setState({selectedGroupCode:groupCode});
        } else {
            this.onSelectCompanyCode(groupCode);
        }
    }

    onConfirm() {
        var groupCode = this.state.selectedGroupCode;
        this.setState({selectedGroupCode:null});
        this.onSelectCompanyCode(groupCode);
    }

    onCancel() {
        this.setState({selectedGroupCode:null});
    }

    onHideError() {
        this.setState({error:'', switchCompanyError:''});
    }


    getContent() {
        if(this.state.showEnterGroupCode && !this.state.error) {
            return (
                <EnterGroupCodeContainer onSelectCompanyCode={this.onSelectCompanyCode} 
                                         switchCompanyError={this.state.switchCompanyError}
                                         onHideError={this.onHideError}
                                         isSwitch={this.props.isSwitch}/>
            );
        } else {
            return (
                <GroupSelect companies={this.state.companies}
                             consumer={this.state.consumer}
                             error={this.state.error}
                             switchCompanyError={this.state.switchCompanyError}
                             busy={this.state.busy}
                             onSelectInvite={this.onSelectInvite}
                             onShowEnterGroupCode={this.onShowEnterGroupCode}
                             showConfirm={this.state.selectedGroupCode!==null}
                             onConfirm={this.onConfirm}
                             onCancel={this.onCancel}
                             onHideError={this.onHideError}
                             isSwitch={this.props.isSwitch}/>
            );
        }
    }

    render() {
        var closeIconOpts = {key:'GroupSelectContainer', name:'chevron left'};
        return (
            <NavControl key='GroupSelectContainer' 
                        onClose={this.state.showEnterGroupCode ? this.onHideEnterGroupCode : null} 
                        closeIconOpts={closeIconOpts}>
                {this.getContent()}
            </NavControl>
      );
  }
}

export default withRouter(connect()(translate('authentication')(GroupSelectContainer)));



// WEBPACK FOOTER //
// ./src/modules/authentication/GroupSelectContainer.js